import React from "react";
import { DocumentType } from "constants/TemplateEditor";
import { BoxIcons, FilePdfOutlined, IconTypes } from "us.icons";

export const getTemplateIcon = (documentType: DocumentType): any => {
  try {
    switch (documentType) {
      case DocumentType.PDF:
        return (
          <BoxIcons
            type={IconTypes.BOX_ICON}
            name="pdf"
            viewBox="-15 0 90 65"
          />
        );
      case DocumentType.SMS:
        return (
          <BoxIcons
            type={IconTypes.BOX_ICON}
            name="sms"
            viewBox="-15 0 90 65"
          />
        );
      case DocumentType.EHF:
        return (
          <BoxIcons
            type={IconTypes.BOX_ICON}
            name="ehf"
            viewBox="-15 0 90 65"
          />
        );
      default:
        return (
          <BoxIcons
            type={IconTypes.BOX_ICON}
            name="global-file"
            viewBox="-15 0 90 65"
          />
        );
    }
  } catch (e) {
    return (
      <BoxIcons
        type={IconTypes.BOX_ICON}
        name="global-file"
        viewBox="-15 0 90 65"
      />
    );
  }
};
